import React from 'react';
import { Toast } from 'react-bootstrap';
import { FaCheckCircle, FaExclamationTriangle, FaTimesCircle, FaSpinner } from 'react-icons/fa';

const Notification = ({ message, type, visible, onClose, index }) => {
  const getColor = () => {
    switch (type) {
      case 'success':
        return 'bg-success text-white';
      case 'failure':
        return 'bg-danger text-white';
      case 'loading':
        return 'bg-primary text-white';
      case 'warning':
        return 'bg-warning text-dark';
      default:
        return '';
    }
  };

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <FaCheckCircle style={{ marginRight: 8 }} />;
      case 'failure':
        return <FaTimesCircle style={{ marginRight: 8 }} />;
      case 'loading':
        return <FaSpinner className="fa-spin" style={{ marginRight: 8 }} />;
      case 'warning':
        return <FaExclamationTriangle style={{ marginRight: 8 }} />;
      default:
        return null;
    }
  };

  const notificationStyle = {
    position: 'fixed',
    top: '10px',
    right: '10px',
    zIndex: 1050
  };

  return (
    <Toast show={visible} onClose={onClose} className={getColor()} style={notificationStyle}>
      <Toast.Header>
        <strong className="me-auto">Notification {index}</strong>
      </Toast.Header>
      <Toast.Body>{getIcon()}{message}</Toast.Body>
    </Toast>
  );
};

export default Notification;